import { SESSION_KEYS } from '@/services/browserStorage'

export function readUnityUAFromURL(): string | null {
  if (typeof window === 'undefined') return null
  const params = new URLSearchParams(window.location.search)
  return params.get('x-unity-user-agent')
}

export const getUnityUA = (): string => {
  if (typeof window === 'undefined') return ''
  const qs = new URLSearchParams(window.location.search)
  return qs.get('x-unity-user-agent') ?? ''
}

export function persistUnityUAFromURL() {
  const ua = readUnityUAFromURL()
  if (ua) sessionStorage.setItem(SESSION_KEYS.unity_user_agent, ua)
}

export function clearUnityUA() {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(SESSION_KEYS.unity_user_agent)
}
